import { render } from "./TheMyCollectionItemsImage.vue?vue&type=template&id=631749d0&scoped=true&ts=true"
import script from "./TheMyCollectionItemsImage.vue?vue&type=script&lang=ts"
export * from "./TheMyCollectionItemsImage.vue?vue&type=script&lang=ts"

import "./TheMyCollectionItemsImage.vue?vue&type=style&index=0&id=631749d0&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-631749d0"]])

export default __exports__